


export type ProjectTimeEntryTypeLimitationType = 'NotAllowed';

export const ProjectTimeEntryTypeLimitationType = {
    NotAllowed: 'NotAllowed' as ProjectTimeEntryTypeLimitationType
};

